import { render, staticRenderFns } from "./ParticipantEdit.vue?vue&type=template&id=2c641b78&scoped=true"
import script from "./ParticipantEdit.vue?vue&type=script&lang=js"
export * from "./ParticipantEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c641b78",
  null
  
)

export default component.exports